import HfReactHelper from 'common/utils/hf-react-helper';

/**
 * Often when sending events to google tag manager, we append either:
 * * "- hsapi" if we are tracking an event related to hellosign api
 * * "- hs" if we are tracking an event related to hellosign
 * * "- hf" if we are tracking an event related to hellofax
 *
 * @param isApi Whether we should return the tracking variant for hellosign api
 * @returns string
 */
export function getTrackingVariant(isApi = false): 'hsapi' | 'hs' | 'hf' {
  if (HfReactHelper.isHelloFax()) {
    return 'hf';
  } else if (isApi) {
    return 'hsapi';
  } else {
    return 'hs';
  }
}
